// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__kTQnb","quantity":"styles_quantity__4jvID","quantityRed":"styles_quantityRed__5raNH","title":"styles_title__eR5cS","emoji":"styles_emoji__umiuN"};